<!-- AI Chatbot Container -->
<div class="ai-chatbot-container" [class.open]="isOpen()">

  <!-- Chat Toggle Button -->
  <!-- <button
    class="chat-toggle-btn"
    (click)="toggleChat()"
    [class.open]="isOpen()"
    title="Toggle AI Chat">
    <mat-icon>{{ isOpen() ? 'close' : 'chat' }}</mat-icon>
  </button> -->

  <!-- Chat Window -->
  @if (isOpen()) {
  <div class="chat-window">

    <!-- Chat Header -->
    <div class="chat-header">
      <h3>AI Assistant</h3>
      <button class="clear-btn" (click)="clearChat()" title="Clear Chat">
        <mat-icon>clear_all</mat-icon>
      </button>
    </div>

    <!-- Chat Messages -->
    <div class="chat-messages">
      @for (message of messages(); track message.timestamp) {
      <div
        class="message"
        [class.user-message]="message.isUser"
        [class.ai-message]="!message.isUser">

        <div class="message-content">
          <div class="message-bubble">
            <p>{{ message.text }}</p>
            <span class="message-time">{{ message.timestamp | date:'shortTime' }}</span>
          </div>
        </div>
      </div>
      }

      <!-- Loading Indicator -->
      @if (isLoading()) {
      <div class="message ai-message">
        <div class="message-content">
          <div class="message-bubble loading">
            <div class="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Chat Input -->
    <div class="chat-input">
      <mat-form-field appearance="outline" class="message-input">
        <input
          matInput
          [(ngModel)]="currentMessage"
          (keypress)="onKeyPress($event)"
          placeholder="Type your message..."
          [disabled]="isLoading()">
      </mat-form-field>

      <button
        type="button"
        (click)="sendMessage()"
        [disabled]="!currentMessage.trim() || isLoading()"
        class="send-btn"
        title="Send Message">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
  }
</div>
